import React from 'react'
import { Container, TituloSessao, BoxDepoimento, BoxDepoimentoFoto, BoxDepoimentoTexto, BoxDepoimentoNome, BoxDepoimentoLegenda } from './Styled'
import imagemJosilene from 'images/pos-cnu-2025/josilene-modesti.png'
import imagemChristian from 'images/pos-cnu-2025/christian-gehrmann.png'

export default function BannerPrincipal () {

	return (
		<Container>

			{/* Título */}
			<TituloSessao>Veja só o que alguns de nossos alunos têm a dizer<br /> sobre ferramentas da Premium:</TituloSessao>

			{/* Item Depoimento */}
			<BoxDepoimento>

				{/* Foto */}
				<BoxDepoimentoFoto src={imagemJosilene} />

				{/* Texto */}
				<BoxDepoimentoTexto>“O diferencial para a minha aprovação foi a trilha Estratégica”</BoxDepoimentoTexto>

				{/* Nome */}
				<BoxDepoimentoNome>Josilene Modesti</BoxDepoimentoNome>

				{/* Legenda */}
				<BoxDepoimentoLegenda>Terceiro lugar Sefaz SC</BoxDepoimentoLegenda>

			</BoxDepoimento>

			{/* Item Depoimento */}
			<BoxDepoimento>

				{/* Foto */}
				<BoxDepoimentoFoto src={imagemChristian} />

				{/* Texto */}
				<BoxDepoimentoTexto>“O Passo Estratégico foi fundamental para as revisões, especialmente nas disciplinas em que eu<br /> tinha mais dificuldade. Utilizei no pré-edital. É um método eficiente de revisão”.</BoxDepoimentoTexto>

				{/* Nome */}
				<BoxDepoimentoNome>Christian Gehrmann</BoxDepoimentoNome>

				{/* Legenda */}
				<BoxDepoimentoLegenda>aprovado no TCE-RJ (2º lugar Auditor de Controle Externo)</BoxDepoimentoLegenda>

			</BoxDepoimento>

		</Container>
	)
}
